import { MantineProvider } from "@mantine/core";
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";
import { Toaster } from "sonner";
import ForgotPassword from "./pages/Auth/ForgotPassword";
import Login from "./pages/Auth/Login";
import Register from "./pages/Auth/Register";

import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import "@mantine/dropzone/styles.css";
import { DashboardProvider } from "./context/DashboardContext";
import { OrganizationsProvider } from "./context/OrganizationsContext";
import Dashboard from "./pages/_Protected/Dashboard";
import EventsPage from "./pages/_Protected/Events";
import NewEventPage from "./pages/_Protected/Events/New";
import SingleEvent from "./pages/_Protected/Events/SingleEvent";
import OrganizationsPage from "./pages/_Protected/Organization";
import NewOrganizationPage from "./pages/_Protected/Organization/NewOrganization";
import SingleOrganization from "./pages/_Protected/Organization/SingleOrganization";
import ThemePreview from "./pages/_Protected/Organization/ThemePreview";
import PageBuilder from "./pages/_Protected/Organization/PageBuilder";
import Overview from "./pages/_Protected/Overview";
import ProfilePage from "./pages/_Protected/Profile";
import NotFound from "./pages/NotFound";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Navigate to="/login" replace />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/register",
    element: <Register />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword />,
  },
  {
    path: "/d",
    element: (
      <DashboardProvider>
        <OrganizationsProvider>
          <Dashboard />
        </OrganizationsProvider>
      </DashboardProvider>
    ),
    children: [
      {
        index: true,
        element: <EventsPage />,
      },
      {
        path: "/d/overview",
        element: <Overview />,
      },
      {
        path: "/d/events",
        element: <EventsPage />,
      },

      {
        path: "/d/events/new",
        element: <NewEventPage />,
      },
      {
        path: "/d/events/:id/edit",
        element: <NewEventPage />,
      },
      {
        path: "/d/events/:id",
        element: <SingleEvent />,
      },
      {
        path: "/d/organizations",
        element: <OrganizationsPage />,
      },
      {
        path: "/d/organization/new",
        element: <NewOrganizationPage />,
      },
      {
        path: "/d/organizations/:id",
        element: <SingleOrganization />,
      },
      {
        path: "/d/organizations/:id/page-builder/:pageType",
        element: <PageBuilder />,
      },
      {
        path: "/d/events/:id/page-builder/:pageType",
        element: <PageBuilder />,
      },
      {
        path: "/d/profile",
        element: <ProfilePage />,
      },
    ],
  },
  {
    path: "/preview/organizations/:id/:themeId",
    element: <ThemePreview />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
]);

export default function App() {
  return (
    <MantineProvider>
      <Toaster position="bottom-right" />
      <RouterProvider router={router} />
    </MantineProvider>
  );
}
